import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  FormControl,
  Checkbox,
  Select,
  MenuItem,
  Tooltip,
  ListItemText,
  Button,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import { format } from "mathjs";
import { getGlobalClientId, getToken,getOrgType } from "../../../../utils/Token";
import useFetch from "../../../../utils/useFetch";
import BaseURL from "../../../../utils/base-uri.json";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { isArray } from "lodash";
import _ from "lodash";



export default function ReportOnsiteOffsiteVendor({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [sitedata, setSiteData] = React.useState([]);
  const [location, setLocation] = React.useState([]);
  const [Emp, setEmp] = React.useState([]);
  useEffect(() => {
    axios
    .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
      getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res?.data?.data);
          if(getOrgType()=="Client"){
            setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const [token,setToken]=useState(getToken())
  const changeClients = (e) => {
    setSelectValue1(e);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const { data: resps } = useFetch(
    "Vendor/GetLocationsByClientId?clientId=" + selectValue1
  );
  useEffect(() => {
    if (resps?.data) {
      setLocation(resps?.data);
    }
  }, [resps]);

  const handleFromDateChange = (event) => {
    setFromDateValue(event);
  };

  const handleToDateChange = (event) => {
    setToDateValue(event);
  };
  const [selectedsite, setSelectedsite] = useState([]);
  const [selectedlocation, setSelectedLocation] = useState([location[0]?.key]);
  const [selectedlocation1, setSelectedLocation1] = useState([location[0]?.key]);
  const [selectedEmp, setSelectedEmp] = useState([]);

  const handleDocTypeChange1 = (event) => {
    setSelectedsite(event.target.value);
  };

  const handleDocTypeChange2 = (event) => {
    setSelectedLocation(event.target.value);
  };
  const handleDocTypeChange3 = (event) => {
    setSelectedLocation1(event.target.value);
  };
  const handleEmpChange = (event) => {
    setSelectedEmp(event.target.value);
  };
  const { data: resp } = useFetch(
    "Vendor/GetVendorsByLocationId?locationID="+selectedlocation
  );
  useEffect(() => {
    if (resp?.data) {
      setSiteData(resp?.data);
    }
  }, [resp]);
  const { data: respo } = useFetch(
    "Vendor/GetEmployeesByOrgId?vendorID="+selectedsite
  );
  useEffect(() => {
    if (respo?.data) {
        setEmp(respo?.data);
    }
  }, [respo]);
  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
 };
 const toQueryString = (obj) => {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
};
const headers = [
  { label: "Vendor Name", key: "vendorName" },
  { label: "Company Name", key: "company" },
  { label: "Business Unit", key: "buName" },
  { label: "Site Name", key: "siteName" },
  { label: "Employee/Visitor Name", key: "visitorName" },
  // { label: "TagNumber", key: "tagNumber" },
  // { label: "BadgeNumber", key: "badgeNumber" },
  { label: "Site Contact", key: "siteContact" },
  { label: "Security Name Checkin", key: "securityNameCheckin" },
  { label: "Last Checkin", key: "employeeCheckin" },
];
const convertToCSV = (data) => {
  const header = headers.map((header) => `"${header.label}"`).join(",");
  const rows = data.map((item) =>
    headers
      .map((header) => {
        // if (header.key === "employeeCheckin") {
        //   return `"${item[header.key]}"`;
        // }
        return `"${item[header.key]}"`;
      })
      .join(",")
  );
  return [header, ...rows].join("\n");
};
const timeZoneOffset = new Date().getTimezoneOffset()
 const getUrl = (url, data) => `${url}${toQueryString(data)}`;
 const downloadCurrentlyOnsite = () => {

  // const timeZoneOffset = new Date().getTimezoneOffset()
  // const downloadURL = BaseURL.baseUrl + BaseURL.OnsiteOffsite.CurrentlyOnsite;
  // const url = getUrl(downloadURL, { location: selectedlocation1, timeZoneOffset: timeZoneOffset });
  axios.get("OnsiteOffsite/CurrentlyOnsite?location="+selectedlocation1+"&timeZoneOffset="+timeZoneOffset+"&DownloadClientData=false").then((res) => {
    if (res?.data?.status === true) {
      if (res?.data?.data) {
        const csvContent = convertToCSV(res?.data?.data);
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "CurrentlyOnsite.csv";
        a.click();
        URL.revokeObjectURL(url);
      }
    }
  })
    .catch((err) => setError(err))
    .finally(() => {
      // setIsDownload(false);
    });
}
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
      {/* <form action="https://fvtestreports.firstverify.com/Reports/OnsiteOffsiteVendorEmployees.aspx" target="_blank" method="post">							
<label>OnsiteOffsiteVendorEmployees.aspx</label>								
		<input type="text" name="location" value="-1" />						
<input type="text" name="vendor"  value="-1"/>								
		<input type="text" name="employee"  value="-1"/>						
		<input type="text" name="clientId" value="1" />						
<input type="text" name="toDate"  value="6/21/2023"/>								
		<input type="text" name="fromDate"  value="6/21/2023"/>						
		<input type="text" name="timeZoneOffset"  value="1"/>						
<input type="submit" value="submit" />								
</form>								 */}
        <form
          action={
            BaseURL?.baseReportUrl+"OnsiteOffsiteVendorEmployees.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                From{" "}
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="fromDate"
                size="small"
                value={fromDateValue || ""}
                onChange={handleFromDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                To
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="toDate"
                size="small"
                value={toDateValue || ""}
                onChange={handleToDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register("client")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Client"
                    name="ClientId"
                    value={selectValue1}
                  />
                }
                MenuProps={MenuProps}
              >
                {client?.map((item, index) => (
                  <MenuItem key={index} value={item?.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Location
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="location"
                value={selectedlocation}
                onChange={handleDocTypeChange2}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {location?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}
                {/* {location.map((doc) => (
                  <MenuItem key={doc.key} value={doc.key}>
                    <Checkbox checked={selectedlocation.indexOf(doc.key) > -1} />
                    <ListItemText primary={doc.value} />
                  </MenuItem>
                ))} */}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Vendor
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="vendor"
                value={selectedsite}
                onChange={handleDocTypeChange1}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {sitedata?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Employee
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="employee"
                value={selectedEmp}
                onChange={handleEmpChange}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {Emp?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item?.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <input type="text" name="timeZoneOffset" value={timeZoneOffset} hidden="true" />
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>

              {fromDateValue == "" ||
              toDateValue == "" ||
              selectValue1 == "" || selectedEmp==""  || selectedsite=="" || selectedlocation==""? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        fromDateValue == "" ||
                        toDateValue == "" ||
                        selectValue1 == ""|| selectedEmp==""  || selectedsite=="" || selectedlocation==""
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token}/>
        </form>

        <br />

        <div>
        <FormControl   className="mx-4" sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Location
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
              
                sx={{ width: "320px", overflow: "hidden" }}
                name="location"
                value={selectedlocation1}
                onChange={handleDocTypeChange3}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {location?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}

              </Select>
            </FormControl>
          
         
         
        
          <Button
          className="mt-2 mx-3"
                  variant="contained"
                  type="submit"
             sx={{padding:"20px",width:"90%"}}
             onClick={downloadCurrentlyOnsite}>
                Currently Onsite Report
                </Button>

        </div>
        {/* <form
          action={
            BaseURL?.baseReportUrl+"CurrentlyOnsite.aspx?menubar=no"
          }
          method="post"
             target="_blank"
           
        >
          <div style={{ marginLeft: "25px" }}>
          

            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Location
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="location"
                value={selectedlocation1}
                onChange={handleDocTypeChange3}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {location?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}

              </Select>
            </FormControl>
          
         
            <input type="text" name="timeZoneOffset" value={timeZoneOffset} hidden="true" />
          </div>
        
          <Button
          className="mt-2 mx-3"
                  variant="contained"
                  type="submit"
             sx={{padding:"20px",width:"90%"}}
             onClick={downloadCurrentlyOnsite}>
                Currently Onsite Report
                </Button>
           
         
          <input type="hidden" name="token" value={token}/>
        </form> */}

      </DialogContent>
    </>
  );
}
